import { render, staticRenderFns } from "./InputNatureOfBusiness.vue?vue&type=template&id=0403001a"
import script from "./InputNatureOfBusiness.vue?vue&type=script&lang=js"
export * from "./InputNatureOfBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports